import { Text, View } from "react-native";
import Markdown from "react-native-markdown-display";

const markdownStyles = {
  body: {
    fontFamily: "Geologica_400Regular",
    color: "#181718",
    fontSize: 15,
    lineHeight: 22,
  },
  paragraph: { marginTop: 0, marginBottom: 8 },
  bullet_list: { marginVertical: 4 },
  ordered_list: { marginVertical: 4 },
  list_item: { marginVertical: 2 },
  strong: { fontFamily: "Geologica_500Medium", color: "#181718" },
};

export type WellbeingSection = { title: string; content: string };

export function formatWellbeingSections(sections: WellbeingSection[]): string {
  return sections
    .map(({ title, content }) => `## ${title}\n\n${content.trim()}`)
    .join("\n\n");
}

export function parseWellbeingSections(markdown: string): {
  title: string;
  content: string;
}[] {
  if (!markdown.trim()) return [];

  const parts = markdown.split(/^## /m).filter((part) => part.trim());

  return parts.map((part) => {
    const newlineIndex = part.indexOf("\n");
    if (newlineIndex === -1) {
      return { title: part.trim(), content: "" };
    }

    return {
      title: part.slice(0, newlineIndex).trim(),
      content: part.slice(newlineIndex + 1).trim(),
    };
  });
}

function WellbeingInsightsSections({ markdown }: { markdown: string }) {
  const sections = parseWellbeingSections(markdown);

  if (sections.length === 0) {
    return (
      <View className="rounded-[17px] border border-gray-200 bg-teachLoop-creamLight px-4 py-3">
        <Markdown style={markdownStyles}>{markdown}</Markdown>
      </View>
    );
  }

  return (
    <View className="gap-3">
      {sections.map((section) => {
        const isRecommendations =
          section.title.toLowerCase() === "recommendations";

        return (
          <View
            key={section.title}
            className={
              isRecommendations
                ? "gap-2 rounded-[17px] border border-teal-200 bg-teal-50/40 px-4 py-3"
                : "gap-2 rounded-[17px] border border-gray-200 bg-teachLoop-creamLight px-4 py-3"
            }
          >
            <Text className="text-base font-geologica-medium font-medium text-gray-800">
              {section.title}
            </Text>
            <Markdown style={markdownStyles}>{section.content}</Markdown>
          </View>
        );
      })}
    </View>
  );
}

export default WellbeingInsightsSections;
